export default __webpack_public_path__ + "static/media/chatIcon.97e3fe3f.png";